<template>
    <div class="features-box">
        <div class="features-item" v-for='(item,index) in titleData' :key='index'>
            <div class="icon" :style='{backgroundImage:"url("+item.iconfont+")"}'></div>
            <h4 class="caption">{{item.caption}}</h4>
            <div class="title" v-html='item.title'></div>
            <div class="center" v-html='item.center'></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Features',
        data() {
            return {
                titleData: [
                    {
                        iconfont: require('../../../../static/shejishijianzhushi.png'),
                        caption: '资深网页设计师',
                        title: '<p>前4A广告公司设计师团队，懂歪果仁的审美风格。让您的独立站在同行中脱颖而出。<p>',
                        center: '<p>Work with experienced web designers to build a professional website tailored for your business — and right for your budget. Our web experts will help you connect with customers and bring your brand to life.</p>'
                    },
                    {
                        iconfont: require('../../../../static/wangzhan.png'),
                        caption: '网站自适应',
                        title: '<p>您需要一种适当于当今消费者浏览习惯的网页设计。</p><p>客户使用的任何设备上都可完美展示的独立站。智能手机、台式机及介于两者之间的所有。</p><p>显示在不同大小终端设备上新网页设计方式及技术。</p>',
                        center: '<p>You need a web design that works for today’s consumer. Get a site that displays properly on any device your customers use. Smartphones, desktop and everything in between — we create easy-to-use websites that look good everywhere.</p>'
                    },
                    {
                        iconfont: require('../../../../static/xiezi.png'),
                        caption: '专业海外写手',
                        title: '<p>Google对于优质的原创文章，在网站的权重越来越青睐,使得对英文文章的写手需求也越来越高。<br/>我们有精通外贸的运营团队和资深海外写手创建高质量的博客内容，为企业提供最本土化高价值的内容输出。传达有关你业务的关键信息。</p>',
                        center: '<p>Our dedicated operations team and overseas writers will create high-quality content that delivers key messages about your business.</p>'
                    },
                    {
                        iconfont: require('../../../../static/videocamera.png'),
                        caption: '专业摄影拍摄',
                        title: '<p>更懂外贸制造企业的拍摄，突出行业产品优势.</p><p>通过我们资深的拍摄团队体现工厂专业的生产流程，呈现中国制造之美。</p>',
                        center: "<p>More understanding of foreign trade manufacturing enterprises shooting, highlighting the advantages of industry products.</p><p>Through our senior shooting team to reflect the factory's professional production process, to present the beauty of Chinese quality.</p>"
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    .features-box {
        display: grid;
        max-width: 76.8%;
        margin: 61px auto 0;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 180px 180px 180px 180px 180px 180px;
        grid-column-gap: 10%;
        grid-template-areas: 'One .'
            'One Two'
            '.   Two'
            'Tree .'
            'Tree From'
            '. From';
        padding-bottom: 240px;
    }

    .features-item {
        position: relative;
    }

    .features-item::after {
        display: block;
        position: absolute;
        font-size: 200px;
        font-weight: bold;
        line-height: 100px;
        color: rgba(255, 255, 255, 1);
    }

    .features-item:nth-of-type(1) {
        grid-area: One;
    }

    .features-item:nth-of-type(2) {
        grid-area: Two;
    }

    .features-item:nth-of-type(3) {
        grid-area: Tree;
    }

    .features-item:nth-of-type(4) {
        grid-area: From;
    }

    .features-item:nth-of-type(1)::after {
        top: 0;
        left: 0;
        transform: translateY(30%);
        content: '01';
    }

    .features-item:nth-of-type(2)::after {
        top: 0;
        right: 0;
        transform: translateY(100%);
        content: '02';
    }

    .features-item:nth-of-type(3)::after {
        top: 0;
        left: 0;
        transform: translateY(30%);
        content: '03';
    }

    .features-item:nth-of-type(4)::after {
        top: 0;
        right: 0;
        transform: translateY(100%);
        content: '04';
    }

    .icon {
        width: 60px;
        height: 60px;
        background: transparent no-repeat center center;
        background-size: 90%;
        margin: 0 auto;
        position: relative;
        z-index: 3;
    }

    .caption {
        text-align: center;
        font-size: 24px;
        color: #333333;
        font-weight: bold;
        margin: 22px 0 35px 0;
        position: relative;
        z-index: 3;
    }

    .title {
        margin-bottom: 20px;
    }

    .title>>>p {
        font-size: 16px;
        color: #1c1c1c;
        line-height: 150%;
        position: relative;
        z-index: 3;
    }

    .center>>>p {
        font-size: 16px;
        font-weight: 400;
        line-height: 150%;
        color: rgba(153, 153, 153, 1);
    }

    @media(max-width: 995px){
        .features-box {
        display: grid;
        max-width: 100%;
        margin: 0 auto;
        grid-template-columns: 1fr;
        grid-template-rows:auto;
        grid-template-areas: 'One'
            'Two'
            'Tree'
            'From';
        padding-bottom:0;
        padding: 5%;
    }

    }

    /* @media(max-width: 1023px) {
        .features-box {
            max-width: 100%;
            padding: 0 5%;
            padding-bottom: 400px;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 588px 588px 588px 588px 588px 588px;
        }

        .title>>>p {
            font-size: 50px;
        }

        .center>>>p {
            font-size: 50px;
        }

        .caption {
            font-size: 75px;
            position: relative;
            z-index: 4;
        }

        .icon {
            width: 120px;
            height: 120px;
        }
    }
    @media(max-width: 320px){
        .features-box {
        grid-template-rows: 888px 888px 888px 888px 888px 888px;
        padding-bottom: 50%;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/features.vue